import { render, staticRenderFns } from "./RouterIdList.vue?vue&type=template&id=36874548&scoped=true&"
import script from "./RouterIdList.vue?vue&type=script&lang=js&"
export * from "./RouterIdList.vue?vue&type=script&lang=js&"
import style0 from "./RouterIdList.vue?vue&type=style&index=0&id=36874548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36874548",
  null
  
)

export default component.exports